<script>
import sl from "@/Prevodi/CamoStartne-sl.json";
import en from "@/Prevodi/CamoStartne-en.json";
import it from "@/Prevodi/CamoStartne-it.json";
import {i18n} from "@/i18n";
import Notification from "@/components/reUse/Notification.vue";
import CamoStartneJadralna from "@/components/pregledi/CamoStartneJadralna.vue";
import CamoStartneUltraLight from "@/components/pregledi/CamoStartneUltraLight.vue";
import DropDown from "@/components/reUse/DropDown.vue";

export default {
  name: "CamoStartne",
  components: {
    DropDown,
    Notification,
    CamoStartneJadralna,
    CamoStartneUltraLight

  },
  data() {
    return {
      prevodi: false,
      prikaz: 'motorna',
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      PodatkiObracun: [],
      sortAscending: false,
      dLetalo: false,
      filterLetalo: '',
      Letala: [],
      printing: false,
      sending: false,
      //obvestila
      ShowNoti: false,
      text: '',
      types: '',
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
  },
  computed: {
      FilterPodatkov() {
        if(this.filterLetalo !== '') {
          return this.PodatkiObracun.filter(izpis => izpis.registracija === this.filterLetalo);
        }
        return this.PodatkiObracun;

    }
  },
  methods: {
    GetPodatkiObracuna() {
      let app = this;
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datumO);
      podatki.append("datumK", this.datumD);
      axios
          .post("./api/log/motorno/izpis/", podatki)
          .then(function (response) {
            app.PodatkiObracun = response.data.podatki.filter(zapis => zapis.camo_pregled);
            // app.CalculateFlights();
            app.AllFlightsTime = response.data.s_cas_letenja;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    ToogleSort() {
      this.sortAscending = !this.sortAscending;
      this.FilterPodatkov.reverse();
    },
    Natisni() {
      this.printing = true;
      let podatki = new URLSearchParams();
      let zapisi = {
        "podatki": JSON.stringify(this.FilterPodatkov),
        "datumO": this.datumO,
        "datumD": this.datumD,
        "s_letov": this.SestejPristanke(),
        "s_trajanje": this.sestejCase(),
        "akcija": "tisk"
      }
      podatki.append('podatkiM', JSON.stringify(zapisi));
      axios.post('./api/camo/startne/pdf/', podatki, {
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });

        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');

        // Po potrebi kasneje sprostiš URL
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.printing = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.printing = false;
      });
    },
    SendToMail() {
      this.sending = true;
      let podatki = new URLSearchParams();
      let zapisi = {
        "podatki": JSON.stringify(this.FilterPodatkov),
        "datumO": this.datumO,
        "datumD": this.datumD,
        "s_letov": this.SestejPristanke(),
        "s_trajanje": this.sestejCase(),
        "akcija": "mail"
      }
      podatki.append('podatkiM', JSON.stringify(zapisi));
      axios.post('./api/camo/startne/pdf/', podatki, {
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });
        const url = URL.createObjectURL(blob);
        // let podatkiMail = new URLSearchParams();
        // podatkiMail.append('datoteka', url);
        // podatkiMail.append('zadeva', 'Izpisek motornih letov');
        const podatkiMail = new FormData();
        podatkiMail.append('datoteka', blob, 'motorni_leti.pdf');
        podatkiMail.append('zadeva', 'Izpisek motornih letov');
        axios.post('./api/camo/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.sending = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.sending = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.sending = false;
      });
    },
    sestejCase() {
      let skupneMinute = 0;
      let skupneUre = 0;
      for (let i = 0; i < this.FilterPodatkov.length; i++) {
        // Pretvori oba časa v minute
        let ure;
        let minute;
        if(this.FilterPodatkov[i].camo_flight) { //če je vklopljen camo flight seštevamo flight težo
          [ure, minute] = this.FilterPodatkov[i].cas_letenja_flight.split(':').map(Number);
        }else {
          [ure, minute] = this.FilterPodatkov[i].cas_letenja.split(':').map(Number);
        }

        skupneMinute += minute;
        skupneUre += ure;
      }
      while (skupneMinute >= 60) {
        skupneMinute -= 60;
        skupneUre++;
      }
      // Formatiraj nazaj v HH:MM
      const ureStr = String(skupneUre).padStart(2, '0');
      const minuteStr = String(skupneMinute).padStart(2, '0');

      return `${ureStr}:${minuteStr}`;
    },
    SestejPristanke() {
      let pristanki = 0;
      for (let i = 0; i < this.FilterPodatkov.length; i++) {
        // Pretvori oba časa v minute
        pristanki += this.FilterPodatkov[i].st_pristankov;
      }
      return pristanki;
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].camo_pregled && response.data.letala[i].vrsta_letala === 'Motorno') {
                app.Letala.push(response.data.letala[i]);
              }
            }
            // app.Letala = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    selectLetalo(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.filterLetalo = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
  }
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <!-- Back Button -->
          <div class="header-section header-left">
            <button class="back-btn" @click.prevent="$router.push('/')">
              <i class="fas fa-angle-double-left"></i>
              <span> {{ $t('startne.buttons.nazajGlavni') }} </span>
            </button>
            &nbsp;
            <button class="back-btn" @click="$router.push('/pregledi/Camo')">
              <i class="fas fa-arrow-left"></i>
              <span> {{ $t('startne.buttons.nazaj') }} </span>
            </button>
          </div>
        </div>
        <!-- Title -->
        <div class="header-section header-center">
          <h1 v-if="prikaz === 'jadralna'" class="page-title">{{$t('startne.nav.jadralna')}}</h1>
          <h1 v-if="prikaz === 'motorna'" class="page-title">{{$t('startne.nav.motorna')}}</h1>
          <h1 v-if="prikaz === 'ultralight'" class="page-title">{{$t('startne.nav.ultralight')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'motorna'}" @click="prikaz = 'motorna'" data-umami-event="Obracun-motorna">
              <i class="fas fa-plane-departure"></i>
              <span>{{$t('startne.main.titleMotorna')}}</span>
            </button>
            <button class="nav-tab" :class="{'active': prikaz === 'jadralna'}" @click="prikaz = 'jadralna'" data-umami-event="Obracun-jadralna">
              <i class="fas fa-paper-plane"></i>
              <span>{{$t('startne.main.titleJadralna')}}</span>
            </button>
            <button class="nav-tab" :class="{'active': prikaz === 'ultralight'}" @click="prikaz = 'ultralight'" data-umami-event="Obracun-ultralight">
              <i class="fas fa-plane-departure"></i>
              <span>{{$t('startne.main.titleUltralight')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <main v-show="prikaz === 'motorna' && prevodi" class="container p-2">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types"  @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6">{{$t('startne.labels.datumOd')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datumO" required @change="GetPodatkiObracuna"/>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" >{{$t('startne.labels.datumDo')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datumD" required @change="GetPodatkiObracuna" />
      </div>
      <!-- LETALO FILTER -->
      <div class="col-12">
        <div class="container">
          <label class="label-dropdown" for="filterLetalo">{{$t('startne.labels.reg')}}<button v-if="filterLetalo !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterLetalo = ''">{{$t('startne.buttons.brisiIzbiro')}}</button></label>
          <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()" >
            <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
            <i v-show="dLetalo" class="fas fa-chevron-down"></i>
          </div>
          <button class="input border-0 rounded-4 p-2 fs-5"  id="filterLetalo" @click.prevent="OpenLetalo">{{filterLetalo}}</button>
          <transition name="fade">
            <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
          </transition>
        </div>
      </div>
      <div class="col-12 p-2">
        <div>
          <div class="row d-flex justify-content-between">
            <h4 class="text-white">{{$t('startne.data.title')}}</h4>
            <div class='col-1 mt-2'>
              <button class="btn btn-sm btn-outline-secondary" @click.prevent="ToogleSort()"><i v-if="sortAscending" class="fas fa-chevron-down"></i> <i v-if="!sortAscending" class="fas fa-chevron-up"></i></button>
            </div>
            <div class='col-4 text-center'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FilterPodatkov.length > 0 || this.printing" @click.prevent="Natisni()" data-umami-event="Obracun-Motorna-izpis-tisk"><i class="fas fa-spin fa-spinner" v-if="this.printing"></i>{{$t('startne.buttons.natisni')}} <i class="fas fa-print"></i></button>
            </div>
            <div class='col-3 text-center'>
              <button class='btn btn-sm btn-outline-warning' :disabled="!FilterPodatkov.length > 0 || this.sending" @click.prevent="SendToMail" data-umami-event="Obracun-Motorna-izpis-email">{{$t('startne.buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin': this.sending}"></i></button>
            </div>
          </div>
          <!-- IZPIS LETOV -->
          <section class="flight-section-pregled mt-2">

            <div class="section-header">
              <div class="section-icon motor">
                <i class="fas fa-plane"></i>
              </div>
              <div class="d-flex col-10 justify-content-between">
                <div>
                  <h2>{{ $t('startne.table.titleM') }}</h2>
                  <span>{{ FilterPodatkov.length }} zapisov</span>
                </div>
                <div >
                  <h2 class="text-success"> {{ $t('startne.data.title').toUpperCase() }}</h2>
                  <span>{{$t('startne.data.stPristankov')}} {{this.SestejPristanke()}}</span>
                </div>
                <div>
                  <h2>{{ $t('startne.data.casVZraku') }}</h2>
                  <span> {{ this.sestejCase() }} </span>
                </div>
              </div>
            </div>

            <div class="flight-list">

              <div
                  class="flight-item-pregled-camo"
                  v-for="(id, index) in FilterPodatkov"
              >
                <div class="flight-task">
                  <span class="label-flight">{{$t('startne.table.datum')}}</span>
                  <strong>{{ id.datum.substring(0,5) }}</strong>
                </div>

                <div class="flight-date">
                  <i class="fas fa-plane"></i>
                  <span>{{ id.registracija }}</span>
                </div>

                <div class="flight-task">
                  <span class="label-flight">{{$t('startne.table.vzlet')}}</span>
                  <strong>{{ (id.camo_flight) ? id.vzlet_flight :  id.cas_vzleta }}</strong>
                </div>

                <div class="flight-task">
                  <span class="label-flight">{{$t('startne.table.pristanek')}}</span>
                  <strong>{{ (id.camo_flight) ? id.pristanek_flight : id.cas_pristanka }}</strong>
                </div>

                <div class="flight-task">
                  <span class="label-flight">{{$t('startne.table.trajanje')}}</span>
                  <strong>{{ (id.camo_flight) ? id.cas_letenja_flight : id.cas_letenja }}</strong>
                </div>
              </div>

              <div v-if="!PodatkiObracun.length" class="empty-state">
                <i class="far fa-folder-open"></i>
                <span>Ni podatkov</span>
              </div>

            </div>

          </section>
        </div>
      </div>
    </div>
  </main>
  <camo-startne-jadralna v-show="prikaz === 'jadralna'" />
  <camo-startne-ultra-light v-show="prikaz === 'ultralight'" />
</template>
<style>
.flight-item-pregled-camo {
  display: grid;

  grid-template-columns: 0.2fr 1fr 1fr 1fr auto;

  align-items: center;

  gap: 20px;

  padding: 13px 15px;

  border-radius: 9px;

  cursor: pointer;

  transition:
      background .2s ease,
      transform .2s ease;
  border: 1px solid gray;
  margin-top: 0.5rem;
}
.flight-item-pregled-camo:hover {
  background: #1e2530;
}
@media (max-width: 900px) {

  .flight-item-pregled-camo {
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    position: relative;
    padding-right: 55px;
    border-bottom: 1px solid gray;
  }
}


@media (max-width: 650px) {

  .flight-item-pregled-camo {
    grid-template-columns: 1fr;
  }
}
</style>